export function getAll() {
  return [
    {
      value: 0,
      name: "AtStore",
      text: "到店取貨",
    },
    {
      value: 1,
      name: "Delivery",
      text: "宅配",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
